/**
 *  interface for Login Type
 */
export enum LoginTypes {
  LOGIN_USER = '@@login/LOGIN_USER',
  LOGIN_SUCCESS = '@@login/LOGIN_SUCCESS',
  LOGIN_INVALID = '@@login/LOGIN_INVALID',
  LOGOUT_USER = '@@login/LOGOUT_USER',
  LOGOUT_USER_SUCCESS = '@@login/LOGOUT_USER_SUCCESS',
  API_ERROR = '@@login/API_ERROR',
  SOCIAL_LOGIN = '@@login/SOCIAL_LOGIN',

  RESET_PASSWORD = '@@login/RESET_PASSWORD',
  RESSET_PASSWORD_SUCCESS = '@@login/RESSET_PASSWORD_SUCCESS',
  RESSET_PASSWORD_FAIL = '@@login/RESSET_PASSWORD_FAIL',

  RESET_STATUS = '@@login/RESET_STATUS',
}
